var transformData,
    transformCredits    = require("app/Domain/Ott/Api/V2/DataTransformers/transformCredits"),
    transformMediaLinks = require("app/Domain/Ott/Api/V2/DataTransformers/transformMediaLinks");

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  media     The media data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformData = transformData = function(language, media) {
    media = transformCredits(media);
    media = transformMediaLinks(language, media);

    if (media.parent && typeof media.parent === "object") {
        media.parent = transformData(language, media.parent);
    }

    return media;
};
